export default function ($translate) {
    return {
        KEYS: {
            CORRECT: 'CORRECT',
            INCORRECT: 'INCORRECT',
            NOT_APPLICABLE: 'NOT_APPLICABLE'
        },
        LABELS: {
            CORRECT: $translate.instant('enums.Correct'),
            INCORRECT: $translate.instant('enums.Incorrect'),
            NOT_APPLICABLE: $translate.instant('enums.Not applicable')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/answer/correctnessType/index.js